<template>
  <div v-if="provinces?.length" class="s-local-search-provinces">
    <SHeading centered level="2" size="2">
      {{ tr("main_site.company_wall.local_search_province.provinces_title") }}
    </SHeading>
    <p class="s-local-search-provinces__description">
      {{
        tr("main_site.company_wall.local_search_province.provinces_description")
      }}
    </p>
    <SButtonList :items="provinces" :max-items="12" />
  </div>

  <template v-else-if="status !== 'error'">
    <SHeadingSkeleton size="2" width="60%" />
    <STextSkeleton font-size="lg" width="25rem" />
    <SButtonListSkeleton />
  </template>
</template>

<script setup lang="ts">
import { useQuery } from "@pinia/colada";
import { computed } from "vue";

import { ziggyUnsafe } from "@solvari/common-fe/integrations";
import { useI18nMainSiteCompanyWall } from "@solvari/translations";
import { getEnv, handleQuery } from "@solvari/utils";

import { useProvinces } from "@/api/localSearch.ts";
import SHeading from "@/atoms/SHeading.vue";
import SHeadingSkeleton from "@/atoms/SHeadingSkeleton.vue";
import STextSkeleton from "@/atoms/STextSkeleton.vue";
import SButtonList from "@/organisms/SButtonList/SButtonList.vue";
import SButtonListSkeleton from "@/organisms/SButtonList/SButtonListSkeleton.vue";

const props = defineProps<{
  geoProductSlug: string;
}>();
const { tr } = useI18nMainSiteCompanyWall();

const localeCode = getEnv().config.localeCode;

const { data, status } = useQuery(useProvinces({ localeCode }, handleQuery));

const provinces = computed(() =>
  data.value?.map((item) => ({
    ...item,
    href: ziggyUnsafe("mainSite.localSearch.province", {
      geoProductSlug: props.geoProductSlug,
      province: item.slug,
    }),
  })),
);
</script>

<style lang="postcss">
.s-local-search-provinces {
  &__description {
    @apply mb-6 text-center text-lg text-slate-700;

    &::first-letter {
      @apply uppercase;
    }
  }
}
</style>
